export default __webpack_public_path__ + "static/media/DJI_0971.MP4.00_04_54_12.Still004.a63b8b97.jpg";